import { jsPDF } from 'jspdf';

const PAGE_WIDTH = 210;
const MARGIN = 14;
const LINE_WIDTH = PAGE_WIDTH - MARGIN * 2;

function appendWrappedText(doc, text, startY) {
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  const lines = doc.splitTextToSize(text || '', LINE_WIDTH);
  let y = startY;

  lines.forEach((line) => {
    if (y > 280) {
      doc.addPage();
      y = 20;
    }
    doc.text(line, MARGIN, y);
    y += 5;
  });

  return y + 4;
}

function appendSignatureBlock(doc, label, signatureDataUrl, signerName, signedAt, startY) {
  let y = startY;
  if (y > 240) {
    doc.addPage();
    y = 20;
  }

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.text(label, MARGIN, y);
  y += 6;

  if (signatureDataUrl) {
    try {
      doc.addImage(signatureDataUrl, 'PNG', MARGIN, y, 70, 28);
      y += 32;
    } catch {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text('[Signature on file]', MARGIN, y);
      y += 6;
    }
  }

  if (signerName) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`Name: ${signerName}`, MARGIN, y);
    y += 5;
  }

  if (signedAt) {
    doc.text(`Signed: ${new Date(signedAt).toLocaleString()}`, MARGIN, y);
    y += 8;
  }

  return y;
}

export function buildSignedContractText(content, { companySigner, clientSigner, signerName, signedAt }) {
  let text = content || '';
  if (companySigner) {
    text += `\n\n--- COMPANY SIGNATORY ---\n${companySigner}`;
  }
  if (clientSigner || signerName) {
    text += `\n\n--- CLIENT SIGNATORY ---\n${clientSigner || signerName}`;
  }
  if (signedAt) {
    text += `\nSigned on: ${new Date(signedAt).toLocaleString()}`;
  }
  return text;
}

export function generateContractPdf({
  title,
  content,
  companySignature,
  companySigner,
  clientSignature,
  clientSigner,
  signerName,
  signedAt,
}) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(title || 'Contract', MARGIN, 20);

  let y = appendWrappedText(doc, content, 30);

  if (companySignature || companySigner) {
    y = appendSignatureBlock(
      doc,
      'Company signature',
      companySignature,
      companySigner,
      null,
      y + 4
    );
  }

  if (clientSignature || clientSigner || signerName) {
    appendSignatureBlock(
      doc,
      'Client signature',
      clientSignature,
      clientSigner || signerName,
      signedAt,
      y + 4
    );
  }

  return doc;
}

export function createContractPdfBlobUrl(options) {
  const doc = generateContractPdf(options);
  const blob = doc.output('blob');
  return URL.createObjectURL(blob);
}

export function createContractPdfDataUrl(options) {
  return generateContractPdf(options).output('datauristring');
}

export function downloadContractPdf(filename, options) {
  generateContractPdf(options).save(filename);
}

export function revokePdfBlobUrl(url) {
  if (url && url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}
